import { render, staticRenderFns } from "./PngIcon.vue?vue&type=template&id=64588373&"
import script from "./PngIcon.vue?vue&type=script&lang=js&"
export * from "./PngIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports